import createReducer from 'utils/redux/createReducer'

const initialState = false

export default createReducer(initialState, {
	CHOOSE_ITEM: (currentState, action) => action.data
})



// WEBPACK FOOTER //
// ./src/reducers/selectedProperty.js